// extracted by mini-css-extract-plugin
export default {"wrapper":"VehicleServiceHistoryDiscount_wrapper__w087A"};